"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop2 = _interopRequireDefault(require("lodash-es/noop"));
var _get2 = _interopRequireDefault(require("lodash-es/get"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Cross = _interopRequireDefault(require("../../Icons/all/Cross"));
var _Spinner = _interopRequireDefault(require("../../Spinner/Spinner"));
var _helper = require("./helper");
var _uniqueIdHelper = _interopRequireDefault(require("../../helpers/uniqueIdHelper"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// sushi

// helpers

var Chips = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var list = _ref.list,
    onAdd = _ref.onAdd,
    gap = _ref.gap,
    helperText = _ref.helperText,
    errorText = _ref.errorText,
    label = _ref.label,
    validator = _ref.validator,
    hideCross = _ref.hideCross,
    minHeight = _ref.minHeight,
    maxWidth = _ref.maxWidth,
    activeColors = _ref.activeColors,
    inertColors = _ref.inertColors,
    disabled = _ref.disabled,
    bgColor = _ref.bgColor,
    loading = _ref.loading,
    loaderProps = _ref.loaderProps,
    hideLabel = _ref.hideLabel,
    triggerKeys = _ref.triggerKeys,
    useBackSpace = _ref.useBackSpace,
    onRemove = _ref.onRemove,
    onChange = _ref.onChange,
    className = _ref.className;
  var _useState = (0, _react.useState)(""),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    inputWidth = _useState6[0],
    setInputWidth = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    focused = _useState8[0],
    setFocused = _useState8[1];
  var inputRef = (0, _react.useRef)({
    value: ""
  });
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        inputRef.current.focus();
      },
      blur: function blur() {
        inputRef.current.blur();
      },
      value: inputRef.current.value
    };
  });

  // get updated values
  var updatedActiveColors = (0, _helper.getActiveColors)(activeColors);
  var updatedInertColors = (0, _helper.getInertColors)(inertColors);
  var updatedLoaderProps = (0, _helper.getLoaderProps)(loaderProps);
  var wrapperClick = function wrapperClick(e) {
    e.preventDefault();
    if (typeof inputRef.current.focus === "function") inputRef.current.focus();
  };
  var handleBlur = function handleBlur() {
    setFocused(false);
  };
  var handleFocus = function handleFocus() {
    setFocused(true);
  };
  var handleRemove = function handleRemove(index, item) {
    return function (e) {
      e.preventDefault();
      onRemove(index, item);
    };
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (triggerKeys.includes(e.key)) {
      e.preventDefault();
      var item = value.trim();
      if (item && isValid(item)) {
        onAdd(item);
        setValue("");
        setInputWidth(0);
      }
    } else if (e.key === "Backspace" && inputRef.current.value.length === 0 && useBackSpace) {
      var lastItemIndex = list.length - 1;
      var lastItem = list[lastItemIndex];
      onRemove(lastItemIndex, lastItem);
    }
  };
  var handleInputWidth = function handleInputWidth(width) {
    setInputWidth(width);
  };
  var handleChange = function handleChange(e) {
    var text = e.target.value;
    var calculatedWidth = (0, _helper.getTextWidth)(text, getComputedStyle(e.target).font);
    setValue(text);
    setError("");
    onChange(text);
    handleInputWidth(calculatedWidth);
  };
  var isValid = function isValid(input) {
    if (!validator(input)) {
      setError(errorText);
      return false;
    }
    return true;
  };
  var chipInputProps = {
    error: error !== "",
    input: (0, _get2["default"])(inputRef, "current.value", list.length),
    activeColors: updatedActiveColors,
    inertColors: updatedInertColors,
    loaderProps: updatedLoaderProps,
    focused: focused,
    disabled: disabled,
    minHeight: minHeight,
    maxWidth: maxWidth,
    loading: loading,
    hideLabel: hideLabel,
    bgColor: bgColor
  };
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    className: className,
    theme: {
      chipInputProps: chipInputProps
    }
  }, /*#__PURE__*/_react["default"].createElement(Chips.Container, {
    gap: gap
  }, /*#__PURE__*/_react["default"].createElement(Chips.Wrapper, {
    onMouseDown: wrapperClick
  }, !hideLabel && /*#__PURE__*/_react["default"].createElement(Chips.Label, {
    listLength: list.length
  }, label), loading && /*#__PURE__*/_react["default"].createElement(Chips.LoaderWrapper, null, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], updatedLoaderProps)), !loading && list.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(Chips.Chip, {
      key: (0, _uniqueIdHelper["default"])("chips")
    }, /*#__PURE__*/_react["default"].createElement("span", null, item), hideCross || !disabled && /*#__PURE__*/_react["default"].createElement(_Cross["default"], {
      onMouseDown: handleRemove(index, item),
      color: focused ? updatedActiveColors.chipCross : updatedInertColors.chipCross,
      style: {
        cursor: "pointer"
      }
    }));
  }), !loading && !disabled && /*#__PURE__*/_react["default"].createElement(Chips.Input, {
    ref: inputRef,
    width: inputWidth,
    value: value,
    onKeyDown: handleKeyDown,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    disabled: disabled
  })), /*#__PURE__*/_react["default"].createElement(Chips.ErrorText, null, error !== "" ? errorText : helperText)));
});
Chips.Container = _styledComponents["default"].div.withConfig({
  componentId: "sc-lgx4bi-0"
})(["margin-top:", ";margin-bottom:", ";"], function (props) {
  return props.gap;
}, function (props) {
  return props.gap;
});
Chips.Label = _styledComponents["default"].span.withConfig({
  componentId: "sc-lgx4bi-1"
})(["user-select:none;font-size:1.8rem;position:absolute;transition:all 0.2s ease;transition-property:top,left;left:1.2rem;top:1.6rem;background:", ";color:", ";", ";"], (0, _helper.getValue)("bgColor"), (0, _helper.getValue)("labelFont"), function (_ref2) {
  var listLength = _ref2.listLength;
  return (0, _helper.getValue)("moveLabel", listLength);
});
Chips.Wrapper = _styledComponents["default"].div.withConfig({
  componentId: "sc-lgx4bi-2"
})(["transition:all 0.2s ease;position:relative;display:flex;gap:0.8rem;flex-wrap:wrap;align-content:flex-start;border:1px solid;border-radius:1rem;padding:1rem;border-color:", ";min-height:", ";max-width:", ";background:", ";"], (0, _helper.getValue)("borderColor"), (0, _helper.getValue)("minHeight"), (0, _helper.getValue)("maxWidth"), (0, _helper.getValue)("bgColor"));
Chips.Input = _styledComponents["default"].input.withConfig({
  componentId: "sc-lgx4bi-3"
})(["transition:color 0.2s ease;margin-left:0.5rem;padding:0.8rem 0;border:none;width:calc(", "px + 1rem);color:", ";background:", ";&:disabled{background:rgba(0,0,0,0);}"], function (props) {
  return props.width;
}, (0, _helper.getValue)("color"), (0, _helper.getValue)("bgColor"));
Chips.ErrorText = _styledComponents["default"].div.withConfig({
  componentId: "sc-lgx4bi-4"
})(["font-size:1.1rem;height:1rem;color:", ";"], (0, _helper.getValue)("helperTxtColor"));
Chips.Chip = _styledComponents["default"].span.withConfig({
  componentId: "sc-lgx4bi-5"
})(["transition:all 0.2s ease;transition-property:background,color;display:flex;justify-content:space-between;align-items:flex-end;padding:0.5rem;border:1px solid;border-radius:0.4rem;border-color:", ";background:", ";color:", ";span{font-size:1.8rem;margin:0 0.5rem;}"], (0, _helper.getValue)("chipBorder"), (0, _helper.getValue)("chipBg"), (0, _helper.getValue)("chipFont"));
Chips.LoaderWrapper = _styledComponents["default"].div.withConfig({
  componentId: "sc-lgx4bi-6"
})(["position:absolute;top:50%;transform:translateY(-50%);width:calc(100% - 1.2rem);text-align:", ";"], (0, _helper.getValue)("loaderAlign"));
Chips.propTypes = {
  onAdd: _propTypes["default"].func,
  onRemove: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  validator: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  loading: _propTypes["default"].bool,
  hideLabel: _propTypes["default"].bool,
  useBackSpace: _propTypes["default"].bool,
  hideCross: _propTypes["default"].bool,
  list: _propTypes["default"].arrayOf(_propTypes["default"].string),
  triggerKeys: _propTypes["default"].arrayOf(_propTypes["default"].string),
  gap: _propTypes["default"].string,
  helperText: _propTypes["default"].string,
  errorText: _propTypes["default"].string,
  label: _propTypes["default"].string,
  minHeight: _propTypes["default"].string,
  maxWidth: _propTypes["default"].string,
  bgColor: _propTypes["default"].string,
  loaderProps: _propTypes["default"].shape({
    size: _propTypes["default"].oneOf(["small", "medium", "large"]),
    color: _propTypes["default"].string,
    align: _propTypes["default"].oneOf(["left", "center", "right"])
  }),
  activeColors: _propTypes["default"].objectOf(_propTypes["default"].string),
  inertColors: _propTypes["default"].objectOf(_propTypes["default"].string)
};
Chips.defaultProps = {
  validator: function validator() {
    return true;
  },
  onAdd: _noop2["default"],
  onRemove: _noop2["default"],
  onChange: _noop2["default"],
  disabled: false,
  hideCross: false,
  loading: false,
  useBackSpace: false,
  hideLabel: false,
  list: [],
  triggerKeys: ["Enter", "Tab", ",", " "],
  gap: "0",
  helperText: "",
  errorText: "",
  label: "",
  maxWidth: "",
  minHeight: "5.8rem",
  bgColor: "white"
};
var _default = exports["default"] = Chips;